import React from "react";
import "./PropertyInsurance.scss";
import fireService from "../../../assets/Services/fire-service.png";
import fireImg from "../../../assets/Services/fire-img.png";

const PropertyInsurance = () => {
  return (
    <>
      <div className="property_service">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${fireService})` }}
          ></div>

          <div className="heading_box">Fire Insurance</div>
          <div className="service_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 my-auto">
                  <div className="left">
                    <h4>Fire Insurance</h4>
                    <ul>
                      <li>Property Insurance</li>
                      <li>Property Damage All Risks</li>
                      <li>
                        Industrial All Risks (IAR) including Business
                        Interruption.
                      </li>
                      <li>Breakdown business interruption</li>
                      <li>Comprehensive Machinery Insurance.</li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img src={fireImg} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyInsurance;
